"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    SinglePinLabel: ()=>SinglePinLabel
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_styled_components_namespaceObject = require("styled-components");
var external_styled_components_default = /*#__PURE__*/ __webpack_require__.n(external_styled_components_namespaceObject);
const StyledPinLabel = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Text).withConfig({
    displayName: "SinglePinLabel__StyledPinLabel"
})([
    "max-width:140px;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;display:box;line-clamp:2;box-orient:vertical;text-shadow:-1px -1px 0 #ffffff,1px -1px 0 #ffffff,-1px 1px 0 #ffffff,1px 1px 0 #ffffff;-webkit-text-stroke:3px #fff;-webkit-text-fill-color:#0068ef;letter-spacing:0.2px;paint-order:stroke fill;"
]);
const SinglePinLabel = (props)=>{
    const { name } = props;
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(StyledPinLabel, {
        bold: true,
        ml: 2,
        color: "primary.base",
        size: 1,
        "data-testid": "single-pin-label",
        children: name
    });
};
exports.SinglePinLabel = __webpack_exports__.SinglePinLabel;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "SinglePinLabel"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
